import React from "react";
const IconNonShoppableCountry = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.999 5.89h2.087c.36-2.068 1.812-3.888 3.913-3.888 1.613 0 2.845 1.074 3.492 2.509l-3.38 3.38H5.103l.45 4.557-1.828 1.83-.721-7.289.995-1.098ZM6 18.003h9l.994-.902.998-10.09-2.23 2.23-.669 6.762H8l-2 2Zm4-14c.704 0 1.566.668 1.878 1.889H8.12C8.432 4.67 9.294 4 10 4Z"
      clipRule="evenodd"
    />
    <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="2" d="m16 5.002-12 12" />
  </svg>
);
export default IconNonShoppableCountry;
